import React, { useState } from "react";
import LoadingButton from "../../dumb/LoadingButton";
import useModal from "../../../hook/useModal";
import DisplayError from "../../dumb/DisplayError";
import useStatusThunk from "../../../hook/useStatusThunk";
import { deleteMemory } from "../../../redux/ducks/memory";

const DeleteMemory = props => {
    const [show, hide, renderModal] = useModal();
    const [d_deleteMemory, status, error, event] = useStatusThunk(deleteMemory);

    event.onSuccess = () => hide();

    return (
        <React.Fragment>
            <button className={"button button--danger " + props.className} onClick={show}>Delete Memory</button>

            {renderModal(
                <React.Fragment>

                    <div className="group">
                        <DisplayError error={error} />
                    </div>

                    <LoadingButton loading={status == "pending"} className="button--danger"  onClick={() => { d_deleteMemory({ memoryID: props.memoryID}) }}>Delete Memory</LoadingButton>
                </React.Fragment>
            )}
        </React.Fragment>
    )
}

export default DeleteMemory;